export const requiredStrings: string[] = [
  'PEOPLE_FOUND_THIS_HELPFUL',
  'FOUND_THIS_HELPFUL',
  'AND',
  'HELPFUL',
  'VERIFIED_BUYER',
];
export const COMBO_REVIEW_CLICK = 'comboReviewClicked';
export const BUNDLE_PRODUCT = 'bundle';
